import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-sorting-menu',
  templateUrl: './sorting-menu.component.html',
  styleUrls: ['./sorting-menu.component.scss']
})

export class SortingMenuComponent implements OnInit {
  @Input() columnDefinitions: any[];
  @Input() displayProperty: string = 'mobileSortingName';

  @Input() activeSortName: string = undefined;
  @Input() activeSortDirection: string = undefined;

  @Output() sortingChange = new EventEmitter();


  constructor(private cdref: ChangeDetectorRef ) { }

  ngOnInit() {
  }


  mobileSort(columnName) {
    if (this.activeSortName === columnName) {
      if (this.activeSortDirection === 'asc') {
        this.activeSortDirection = 'desc';
      } else {
        this.activeSortDirection = 'asc';
      }
    } else {
      this.activeSortName = columnName;
      this.activeSortDirection = 'asc';
    }
    this.sortingChange.emit({
      id: this.activeSortName,
      start: this.activeSortDirection
    });
  }


  getSortingName(sortingColumnName) {
    const columns = this.columnDefinitions.filter(item => item.columnName === sortingColumnName);
    if (columns && columns.length > 0) {
      return columns[0][this.displayProperty];
    } else {
      return '';
    }
  }

}
